import React from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'

export default
@withRouter
class ScrollAfterNav extends React.Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
    location: PropTypes.shape({}).isRequired,
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname },
      history: { action },
    } = this.props

    const {
      location: { pathname: prevPathname },
    } = prevProps

    // scrolls back to top when a new route is accessed
    // other actions like back ("POP") are ignored
    if (pathname !== prevPathname && action === 'PUSH') {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return null
  }
}
